module.exports = __webpack_public_path__ + "img/Self-Improvement.9a5445c1.png";